import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { Grid, Breadcrumbs, Link, Button, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, Tooltip } from '@material-ui/core';
import { checkApiStatus, onCheckPermission } from '../../../utils_v2';
import { PageLoader } from '../../../shared_elements';
import { globalGetService,  globalPutService } from '../../../utils_v2/globalApiServices';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import appConfig from '../../../config';
import VisibilityIcon from '@material-ui/icons/Visibility';
import GetAppIcon from '@material-ui/icons/GetApp';
import { testLessor, titanAviInstance, castleAirInstance } from '../../../shared_elements/components';

const DocsFileList = ({params,file, fileLinkInfo, toggleModalFn, getResponseBack,is}) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [checkListData, setCheckListData] = useState({navigation:[],folders:[],files_in_current_folder:[]})
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFolders, setSelectedFolders] = useState([]);
  const [lastSelectedFolder, setLastSelectedFolder] = useState(fileLinkInfo.checkList.last_used_folder_uuid || null);
  useEffect(() => {
    if (fileLinkInfo.modal) {
      getCheckListLinkData(lastSelectedFolder||fileLinkInfo.checkList.last_used_folder_uuid, (titanAviInstance || testLessor || castleAirInstance) ?'root':'');
    }
  }, [fileLinkInfo.modal]);
  const getCheckListLinkData = (uuid, root) => {
    let queryParams={}
    if(root =='root'){
       queryParams = {show_root_folders:true}
    }
    setLoading(true);
    globalGetService(`technical/v2/workorder/${params.workOrderSlug}/record-folders-files/${uuid}/?asset_type=${params.type}`, {...queryParams, showFiles:true})
      .then(response => {
        setLoading(false);
        if(checkApiStatus(response)){
          setCheckListData(response.data.data);
          setLastSelectedFolder(uuid)
        }
      })
  }
  const downloadFile = (file) => {
    axios.get(decodeURIComponent(file.path),{timeout: 600000, responseType : 'blob'})
    .then(response => {
      const pathExt = decodeURIComponent(file.path).split('?')[0].split('.').pop();
      const fileName = /\.[a-z0-9]+$/i.test(file.name) ? file.name : `${file.name}.${pathExt}`;
      const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      setTimeout(() => { link.remove(); window.URL.revokeObjectURL(url); }, 1000);
    })
    .catch(() => window.open(decodeURIComponent(file.path)))
  }
  const onAddRemoveFile = (flag, file) => {
    if(file?.type =='folder'){
      if(flag){
        setSelectedFolders([...selectedFolders, file]);
      }else{
        setSelectedFolders(selectedFolders.filter(item => item.id !== file.id));
      }
    }
    else{
      if(flag){
        setSelectedFiles([...selectedFiles, file]);
      }else{
        setSelectedFiles(selectedFiles.filter(item => item.id !== file.id));
      }
    }
  }
  const onSubmitFileLink = () => {
    let payload = {
      file_ids: selectedFiles.map(file => file.id).join(','),
      folder_ids: selectedFolders.map(file => file.id).join(','),
    };
    setLoading(true)
    globalPutService(`technical/v2/workorder/${params.workOrderSlug}/document-checklists/${fileLinkInfo.checkList.id}/?asset_type=${params.type}`, payload)
    .then(response => {
        setLoading(false)
        if(checkApiStatus(response)){
          toggleModalFn();
          getResponseBack(response.data.data);
          enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}})
        }else{
          enqueueSnackbar(response.data.message, { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}})
        }
      });
  }
  return(
    <Fragment>
      <Dialog
        open={fileLinkInfo.modal}
        onClose={() => toggleModalFn()}
        className='project-management-modal'
        maxWidth='lg'
      >
        <DialogTitle id="scroll-dialog-title">Link File(s)</DialogTitle>
        {
          onCheckPermission('records','data_room','R')?
        <DialogContent dividers={true}>
          <div style={{width:'720px'}} className='checklist-file-linking'>
            <Grid container spacing={1}>
              <Grid item md={7}>
                <div className='linking-navigation'>
                  <Breadcrumbs maxItems={3} aria-label="breadcrumb">
                  { (titanAviInstance || testLessor || castleAirInstance) ?
                  <Link key={'datarom'} onClick={(e)=>(checkListData?.navigation[0]?.uuid? getCheckListLinkData(checkListData?.navigation[0]?.uuid,'root'): e.preventDefault())}  className="list-inline-item navigation_modal" >Dataroom</Link>
                  : null}
                    {checkListData.navigation.map((nav, index) =>
                      checkListData.navigation.length - 1 === index ?
                        <Link key={index} onClick={() => getCheckListLinkData(nav.uuid)} className="list-inline-item navigation_modal">{nav.name}</Link>
                        :
                        <Link key={index} onClick={() => getCheckListLinkData(nav.uuid)} className="list-inline-item navigation_modal">{nav.name}</Link>
                    )}
                  </Breadcrumbs>
                </div>
                <Grid container spacing={1}>
                  {checkListData.folders.length  ||  checkListData.files_in_current_folder.length ?
                    <>
                      {checkListData.folders.map((folder, index) =>
                        <Grid item md={12} key={index}>
                          <Grid container spacing={0}>
                            <Grid item md={9}>
                              <h4 className='flex-centered' onClick={() => getCheckListLinkData(folder.uuid)}>
                                <FolderOpenIcon color='primary' fontSize='small' /> <span>{folder.name}</span>
                              </h4>
                            </Grid>
                            <Grid item md={3} style={{ display: 'flex', alignItems: "center", justifyContent: 'flex-end' }}>
                              {(() => {
                                 let linkedfiles = fileLinkInfo.checkList?.folders?.map((linkid)=>linkid)
                                return (
                                  <Checkbox
                                    checked={selectedFolders.map(item => item.id).includes(folder.id) ? true : false}
                                    onChange={(e) => onAddRemoveFile(e.target.checked, folder)}
                                    color='primary'
                                    size='small'
                                    disabled={linkedfiles?.map(item=>item?.id)?.includes(folder?.id)}
                                  />
                                )
                              })()}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                      {checkListData.files_in_current_folder.map((file, index) =>
                        <Grid item md={12} key={index}>
                          <Grid container spacing={0}>
                            <Grid item md={9}>
                            <h4 className='flex-centered' style={{flexFlow:"row"}}>
                                <InsertDriveFileIcon color='primary' fontSize='small' />
                                <span style={{wordBreak:"break-word"}}>{file.name}</span>
                                {/* <span style={{color:'#5c99df', textDecoration:'underline'}} onClick={()=>window.open(appConfig.domain.records+'records/preview/'+file.uuid)}>&nbsp;Preview</span> */}
                              </h4>
                              <p className='file-location'>{file.location}</p>
                            </Grid>
                            <Grid item md={3} style={{display:'flex', alignItems:"center", justifyContent:'flex-end', gap:'6px'}}>
                            {file.path ?
                              <Tooltip title='Download File' arrow>
                                <a href={decodeURIComponent(file.path)} download={file.name} onClick={(e) => { e.preventDefault(); downloadFile(file); }} style={{display:'flex'}}><GetAppIcon color="primary" fontSize='small' /></a>
                              </Tooltip> : null
                            }
                            <Tooltip title='Preview File' arrow>
                              <VisibilityIcon style={{cursor:'pointer'}} onClick={() => window.open(appConfig.domain.records + 'records/preview/' + file.uuid)} color='primary' fontSize='small' />
                              </Tooltip>
                            {(() => {
                             let linkedfiles = fileLinkInfo.checkList.files.map((linkid)=>linkid)
                               return (
                                 <Tooltip title={linkedfiles.map(item => item.id).includes(file.id) ? "This File is already linked" : ""} arrow>
                                   <span>
                                     <Checkbox
                                       checked={selectedFiles.map(item => item.id).includes(file.id) ? true : false}
                                       onChange={(e) => onAddRemoveFile(e.target.checked, file)}
                                       color='primary'
                                       size='small'
                                       disabled={linkedfiles.map(item => item.id).includes(file.id)}
                                     />
                                   </span>
                                 </Tooltip>
                               )
                            })()}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </>
                    :<Grid item md={12}>
                      <p style={{textAlign:'center'}}>No folder / file(s) found</p>
                    </Grid>
                  }
                </Grid>
              </Grid>
              <Grid item md={5} style={{borderLeft: '1px solid #d7d7d7'}}>
                <div className='selected-files'>
                  <h3>Selected File's/Folder's ({selectedFiles.length + selectedFolders?.length})</h3>
                  {selectedFiles.length || selectedFolders?.length ?
                    <div className='selected-files-blk'>
                      {[...selectedFolders, ...selectedFiles].map((file, index) =>
                        <div className='file-list' key={index}>
                          <div>
                            <h4 style={{wordBreak: "break-word"}}><span>{file.name}</span></h4>
                            <p>{file.location}</p>
                          </div>
                          <span onClick={() => onAddRemoveFile(false, file)} className='remove-file'><RemoveCircleIcon color='secondary' fontSize='small' style={{cursor: "pointer"}} /></span>
                        </div>
                      )}
                    </div>:<p style={{textAlign:'center',background:'#fff'}}>No file(s) selected</p>
                  }
                </div>
              </Grid>
            </Grid>
          </div>
        </DialogContent>:
        <DialogContent dividers={true}>
           <div style={{height:"100px",width:'345px', textAlign:'center'}} className='checklist-file-linking'>
          You do not have permissions to Link file/folder from the dataroom. Please contact Project lead for the access.
           </div>
        </DialogContent>
        }
        <DialogActions>
          <Button onClick={() => toggleModalFn()} color="primary" variant='outlined' size='small'>Cancel</Button>
          { selectedFiles.length ||selectedFolders?.length?
            <Button onClick={onSubmitFileLink} variant="contained" color="primary" size='small'>Save</Button>:null
          }
        </DialogActions>
      </Dialog>
      { isLoading ? <PageLoader/>:null }
    </Fragment>
  )
}
export default withRouter(DocsFileList);
